<div class="d-flex align-items-center">
  @if (label && labelType !== labelTypeOptions.PLACEHOLDER) { @if (labelType === labelTypeOptions.STATIC) {
  <div class="d-flex gap-1 align-items-center">
    <ng-container [ngTemplateOutlet]="labelTemplate"></ng-container>
    @if (inputLabelTooltipText?.length) {
    <finxone-platform-tooltip
      [content]="inputLabelTooltipText"
      [textStyleClass]="tooltipTextStyleClass"
      [borderRadiusClass]="tooltipBorderRadiusClass"
    ></finxone-platform-tooltip>
    }
  </div>
  } @else {
  <ng-container [ngTemplateOutlet]="labelTemplate"></ng-container>
  } }

  <div class="switch-wrapper">
    <finx-switch
      [checkedValue]="control.value ?? false"
      [isSmallSwitchButton]="isSmallSwitchButton"
      [toggleActiveBgColour]="toggleActiveBgColour"
      [toggleInactiveBgColour]="toggleInactiveBgColour"
      (checkedValueChange)="onSwitchChange($event)"
    ></finx-switch>
  </div>

  <ng-container *ngIf="infoText">
    <div [innerHTML]="infoText | safeHtml"></div>
  </ng-container>

  <div *ngIf="showErrors && control?.invalid && control?.dirty" class="error-container" role="alert">
    <div class="is-vertical-align mt-1">
      @for (error of control.errors | keyvalue; track error.key) {
      <small class="typog-xs text-error">
        {{ getErrorMessageBasedOnKey(error) }}
      </small>
      }
    </div>
  </div>
</div>

<ng-template #labelTemplate>
  <label class="labelText labelIdle labelConfig" [for]="id || name">{{ label }}</label>
</ng-template>
